import { Settings, WidgetData } from './data'
import { Widget } from './widget'

export type BlockQuoteData = WidgetData & {
  settings: Settings & {
    blockquote_content: string
    author_name: string
    tweet_button_label: string
  }
  widgetType: 'blockquote'
}

export class BlockQuoteWidget extends Widget {
  blockquote_content: string
  author_name: string
  tweet_button_label: string

  constructor (data: BlockQuoteData) {
    super(data)
    this.blockquote_content = data.settings.blockquote_content
    this.author_name = data.settings.author_name
    this.tweet_button_label = data.settings.tweet_button_label
  }
}
